import { iconNames, type IconName } from './icon'

export function getIconName(name: string) {
	if (iconNames.includes(name as IconName)) {
		return name as IconName
	} else {
		throw new Error(`Invalid icon name: ${name}`)
	}
}
